import { FC } from "react";
import styled from "styled-components";

const Container = styled.div`
    position: relative;
    display: grid;
    grid-gap: 20px;
    grid-auto-flow: column;
    overflow-y: hidden;
    overflow-x: auto;

    &::before {
        content: "";
        width: 105px;
        @media (max-width: 1240px) {
            width: 10px;
        }
    }
    &::after {
        content: "";
        width: 105px;
        @media (max-width: 1240px) {
            width: 10px;
        }
    }

    &::-webkit-scrollbar {
        display: none;
    }
`;

const DefaultCardList: FC<{ children: React.ReactNode }> = ({ children }) => {
    return <Container>{children}</Container>;
};

export default DefaultCardList;
